import { CLOSE_DRAWER, OPEN_DRAWER } from "./DrawerTypes";

export const handleDrawerClick = () => {
    return async (dispatch, getState) => {

        const state = getState();
        const showDrawer = state.drawer.showDrawer;

        if (showDrawer) dispatch({ type: CLOSE_DRAWER })
        else dispatch({ type: OPEN_DRAWER })
    }
}
